export default "__VITE_ASSET__D_d7P65D__"